export enum DestinationBlockType {
  Title = 'title',
  Body = 'body',
  Image = 'image',
  Video = 'video',
}
